module.exports = __webpack_public_path__ + "media/images/flags/32/Mongolia-883427a6197a279cc2e8e55546e36358.png";